export default __webpack_public_path__ + "static/media/audio.bb17b133.mp3";